import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod/v4";

import { getGarageQueryOptions } from "./get-garage";
import { getGaragesQueryOptions } from "./get-garages";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";
import type { Garage } from "@/types/garage";

export const updateGarageInputSchema = z.object({
  name: z.string().nonempty(),
});

export type UpdateGarageInput = z.infer<typeof updateGarageInputSchema>;

export const updateGarage = async ({
  data,
  garageId,
}: {
  data: UpdateGarageInput;
  garageId: string;
}): Promise<Garage> => {
  return await api.patch(`/carburate/garages/${garageId}/`, data);
};

type UseUpdateGarageOptions = {
  mutationConfig?: MutationConfig<typeof updateGarage>;
};

export const useUpdateGarage = ({ mutationConfig }: UseUpdateGarageOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      queryClient.refetchQueries({
        queryKey: getGarageQueryOptions(data.identifier).queryKey,
      });
      queryClient.refetchQueries({
        queryKey: getGaragesQueryOptions().queryKey,
      });
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: updateGarage,
  });
};
